<template>
	<div>
		<p class="o-title">收件人信息</p>
          <div class="o-address">
            <!-- 收货信息 -->
            <p class="o-address-p">
              <span class="title">收货信息</span>
              <span class="text" :title='addressData.name + "，" + addressData.phone + "，" + addressData.province + "，" + addressData.city + "，" + addressData.region + "，" + addressData.address'>
                {{addressData.name}}，{{addressData.phone}}，{{addressData.province}} {{addressData.city}} {{addressData.region}} {{addressData.address}}
              </span>
              <a 
                v-show="detailData.canModifyAddr" 
                href="javascript:void(0)" 
                class="oprate" 
                @click="showAddressDialog" 
                data-xeslog-params="key=xeslog_web_orderDetail_addr_ocenter&action=click_modify_addr">
                修改地址
              </a>
              <span v-show="detailData.seeExpress"  class="oprate" @click="showLogisticsDialog" data-xeslog-params="key=xeslog_web_orderDetail_express_ocenter&action=click_look_express">查看物流</span>
            </p>
            <!-- 配送方式&快递单号 （去掉配送方式&快递单号） -->
            <!-- <div v-if="detailData.expressInfo">
              <p class="o-address-p no-border-top">
                <span class="title">配送方式</span>
                <span class="text">
                  <em v-for="(logisticsCompany, index) in detailData.expressInfo.logisticsCompanyName" :key="index">{{logisticsCompany}}
                    <em class="vertical-line" v-if="index < (detailData.expressInfo.logisticsCompanyName.length - 1)">|</em>
                  </em>
                </span>
              </p>
              <p class="o-address-p">
                <span class="title">快递单号</span>
                <span class="text">
                  <span v-for="(logistics, index1) in detailData.expressInfo.logisticsNo" :key="index1">
                    <span v-for="(logisticsItem, index2) in logistics" :key="index2">
                        <em>{{logisticsItem}}</em>
                        <em v-if="index2 < (logistics.length - 1)">，</em>
                        <em class="vertical-line" v-if="index2 == (logistics.length - 1)">|</em>
                    </span>
                  </span>
                </span>
                <span class="oprate" @click="showLogisticsDialog" data-xeslog-params="key=xeslog_web_orderDetail_express_ocenter&action=click_look_express">查看物流</span>
              </p>
            </div> -->
          </div>
	</div>
</template>
<script>
export default {
  created () {
    // 处理预购卡和其它订单接口字段不一样
    this.privateData = JSON.parse(JSON.stringify(this.detailData))
  },
  data () {
    return {
      privateData: {}
    }
  },
  methods: {
    // 显示 添加／修改地址弹框
    showAddressDialog () {
      this.$emit('showAddressDialog')
    },
    // 查看物流
    showLogisticsDialog () {
      this.$emit('showLogisticsDialog')
    }
  },
  props: ['detailData', 'addressData']
}
</script>
<style lang="less" scoped>
  .o-title{
    font-weight: bolder;
    padding-bottom: 10px;
  }
  .o-address{
    margin-bottom: 20px;
    .title{
      min-width: 90px;
      display: inline-block;
      padding: 15px 20px;
      border-right: solid 1px #E0E0E0;
    }
    .text{
      display: inline-block;
      padding: 15px 20px;
      color: #333333;
      max-width: 820px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: bottom;
      border-left: 0;
    }
    .pre-sell-text {
      border-right: none;
      border-left: solid 1px #E0E0E0;
      p {
        color: #666;
        font-size: 12px;
        line-height: 14px;
        padding: 0;
        & + p {
          margin-top: 9px;
        }
      }
    }
    .oprate{
      cursor: pointer;
      color: #f13232;
      margin-left:5px;
    }
    .border-bottom{
      border-bottom: solid 1px #E0E0E0;
    }
  }
  .o-address{
    .o-address-p{
      border: solid 1px #E0E0E0;
      &:not(:first-child){
        border-top: none;
      }
      .title{
        text-align: right;
      }
      .red{
        color: #ff0021;
      }
    }
    .no-border-top{
      border-top: none;
    }
  }
  .vertical-line{
    display: inline-block;
    margin: 0 10px 0 7px;
    color:#666666;
  }
</style>


// WEBPACK FOOTER //
// module/order/src/components/sub/addressInfo.vue